import { SIZE } from '@app/src/ui';
import styled from 'styled-components';

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  padding: 0 15px;

  @media (min-width ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;
